module.exports = __webpack_public_path__ + "static/support-contracts-fce3a81e24fb48fb2dcc6e92a5ab96ef.jpg";